export const META_CATEGORIES_SHOPIFY = {
  METAFIELD: 'platform.fields.METAFIELD_SHOPIFY'
}